/**
 * useFamilyMine — shared hook for the current parent's family profile.
 * Centralises the `family-mine` React Query call so that hooks like
 * useCompanionName and useDashboardPreferences don't each duplicate the config.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useAuth } from '@/contexts/AuthContext';
import type { FamilyMine, ApiResponse } from '@/types/api';

export function useFamilyMine() {
  const { user } = useAuth();

  return useQuery<ApiResponse<FamilyMine>>({
    queryKey: ['family-mine'],
    queryFn: () => api.families.getMine(),
    enabled: user?.role === 'parent',
    staleTime: 5 * 60 * 1000,
  });
}
